import React from "react";
import { ChevronDown } from "lucide-react";
import { useIntl } from "react-intl";
import { BaseDropdown } from "@components/library/UI/BaseDropdown";
import { SHADOW_STYLE } from "../../../constants";
import "./ShadowStyleSelect.sass";

const CHEVRON_SIZE = 14;

const OPTIONS = [
  { value: SHADOW_STYLE.REGULAR, labelKey: "futures.chart.candle_colors.shadow_regular" },
  { value: SHADOW_STYLE.THICK, labelKey: "futures.chart.candle_colors.shadow_thick" },
];

/**
 * «Shadow style» row of CandleColorsModal (po-chart-visual-spec.md §4, E18):
 * a label and a select Regular / Thick built on the shared BaseDropdown.
 *
 * @param {object}   props
 * @param {string}   props.value    - SHADOW_STYLE value
 * @param {Function} props.onChange - (value: string) => void
 */
const ShadowStyleSelect = ({ value, onChange }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const selected = OPTIONS.find((option) => option.value === value) || OPTIONS[0];

  const trigger = (
    <button
      type="button"
      className="shadow-style-select__trigger"
      aria-haspopup="listbox"
      aria-label={t("futures.chart.candle_colors.shadow_style")}
    >
      <span>{t(selected.labelKey)}</span>
      <ChevronDown size={CHEVRON_SIZE} aria-hidden="true" />
    </button>
  );

  return (
    <div className="shadow-style-select">
      <span className="shadow-style-select__label">
        {t("futures.chart.candle_colors.shadow_style")}
      </span>
      <BaseDropdown
        trigger={trigger}
        className="shadow-style-select__dropdown"
        menuClassName="shadow-style-select__menu"
        align="left"
        useMenuPortal
        matchTriggerWidth
      >
        {({ closeDropdown }) => (
          <div role="listbox">
            {OPTIONS.map((option) => {
              const isSelected = option.value === selected.value;

              return (
                <button
                  key={option.value}
                  type="button"
                  role="option"
                  aria-selected={isSelected}
                  className={`shadow-style-select__option${
                    isSelected ? " shadow-style-select__option--selected" : ""
                  }`}
                  onClick={() => {
                    onChange(option.value);
                    closeDropdown();
                  }}
                >
                  {t(option.labelKey)}
                </button>
              );
            })}
          </div>
        )}
      </BaseDropdown>
    </div>
  );
};

export default ShadowStyleSelect;
